import { render, staticRenderFns } from "./FindWords.vue?vue&type=template&id=4cd6da9e&scoped=true"
import script from "./FindWords.vue?vue&type=script&lang=js"
export * from "./FindWords.vue?vue&type=script&lang=js"
import style0 from "./FindWords.vue?vue&type=style&index=0&id=4cd6da9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6da9e",
  null
  
)

export default component.exports